import { strategyTVL, totalValue, } from "@cachables";
import { brktToUsd, usdToBrkt, } from "@store/commons";
import type { LoadedVault, } from "@types";


export const getPlatformTVL = async ( vaults: LoadedVault[], ) => {

	try {


		let stategy_tvl = 0;

		for(const v of vaults) {

			if(v.closed)
				continue;

			const tvl = await strategyTVL({ vault: v, });
			stategy_tvl += tvl.usd;

		}

		const total_brkt = await totalValue();
		const total_brkt_usd = await brktToUsd(total_brkt);
		const total_usd = stategy_tvl + total_brkt_usd;

		return {
			brkt: (await usdToBrkt(total_usd)).toString(),
			usd: total_usd,
		}
	}
	catch(err) {

		console.warn("failed gaining platform tvl", err);

		return {
			brkt: "0",
			usd: 0,
		}

	}

};
